import { Tooltip } from 'antd'
import { FC, ReactNode } from 'react'
import styled from 'styled-components'

const HoverTerm = styled.span`
  text-decoration: underline dotted;
  text-underline-offset: 2px;
  cursor: help;
`

/**
 * Wraps a variable symbol, label, or value in a hover tooltip describing what
 * it represents (dotted underline + `cursor: help`). The single hover-term
 * affordance for the Minimum Thickness step -- used for input symbols,
 * calculated-output labels, and the substituted values inside each formula.
 *
 * When `description` is absent, renders `children` untouched -- callers that
 * don't supply a description see no visual change.
 */
export const DescribedTerm: FC<{
  description?: ReactNode
  children: ReactNode
}> = ({ description, children }) => {
  if (!description) return <>{children}</>
  return (
    <Tooltip title={description}>
      <HoverTerm>{children}</HoverTerm>
    </Tooltip>
  )
}
